import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  numpad: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttons: {
    maxWidth: '340px',
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },

  num1: {
    border: '0.5px solid #DEDEDE',
    borderTop: 0,
    borderLeft: 0,
  },
  num2: {
    border: '0.5px solid #DEDEDE',
    borderTop: 0,
  },
  num3: {
    border: '0.5px solid #DEDEDE',
    borderTop: 0,
    borderRight: 0,
  },
  num47: {
    border: '0.5px solid #DEDEDE',
    borderLeft: 0,
  },
  num58: {
    border: '0.5px solid #DEDEDE',
  },
  num69: {
    border: '0.5px solid #DEDEDE',
    borderRight: 0,
  },
  numReset: {
    border: '0.5px solid #DEDEDE',
    borderLeft: 0,
    borderBottom: 0,
  },
  num0: {
    border: '0.5px solid #DEDEDE',
    borderBottom: 0,
  },
  numBackspace: {
    border: '0.5px solid #DEDEDE',
    borderRight: 0,
    borderBottom: 0,
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',

    padding: '0 !important',
    '& *': {
      width: '55px',
    },
  },
  button: {
    boxSizing: 'border-box',
    width: '33%',
    height: '70px',
    textAlign: 'center',
    paddingTop: '20px',
    fontWeight: 700,
    fontSize: '25px',
    lineHeight: '28px',
    color: '#878787',
    cursor: 'pointer',
  },
  closeNumpad: {
    marginLeft: '15px',
    cursor: 'pointer',
  },
  numpadTitle: (props: { isMobile: boolean }) => {
    return {
      marginLeft: !props.isMobile ? '46px' : undefined,
      width: '100%',
      fontWeight: 700,
      fontStyle: 'normal',
      fontSize: props.isMobile ? '25px' : '28px',
      textAlign: 'center',
    }
  },
  numberField: {
    display: 'flex',
    marginBottom: '15px',
  },
  numberFieldInput: (props: { isMobile: boolean; baseColors: BaseColors }) => {
    return {
      width: '200px',
      border: '5px solid #dedede',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '48px',
      lineHeight: '58px',
      borderRadius: '20px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      '&:focus': {
        border: `5px solid ${props.baseColors.primary}`,
        outline: 'none',
      },
    }
  },
  numberFieldText: {
    fontSize: '48px',
    color: '#aeaeae',
    marginLeft: '10px',
  },
  confirmButton: (props: { isMobile: boolean; baseColors: BaseColors }) => {
    return {
      display: 'flex',
      margin: '15px',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50px',
      width: '80%',
      borderRadius: '15px',
      backgroundColor: props.baseColors.secondary,
      cursor: 'pointer',
      color: '#fff',
    }
  },
  confirmButtonSpan: {
    height: '33px',
    display: 'inline-block',
    letterSpacing: '0.05em',
    lineHeight: '33px',
    fontSize: '25px',
    fontFamily: 'Mulish',
  },
  disabledButton: () => {
    return {
      backgroundColor: '#E7E7E7',
      color: '#111',
    }
  },
}))

export default buildStyles
